<template>
  <van-dialog
    v-model="show"
    overlayClass="member-modal-overlay"
    class="member-modal-box"
    :class="displayLayout"
    :show-confirm-button="false"
    :close-on-click-overlay="true"
    @closed="close"
  >
    <div class="modal-body flex-col-center">
      <!-- 点击除button栏之外的任意位置，关闭弹窗 -->
      <div class="flex-col-center" @click="close">
        <p class="title">{{ $t('memberShare.congratulations') }}</p>
        <img
          v-if="level"
          v-lazy="require(`@/assets/images/member/medal_${level}.png`)"
          class="medal-level"
          :alt="`medal-${level}`"
        />
        <p class="desc">
          {{ textFormat($t('memberShare.levelUp'), levelUp) }}
          {{ $t('memberShare.exceedPercent', { percent: exceedPercent }) }}
        </p>
        <div class="dividing-line">{{ $t('memberShare.upgradeReward') }}</div>
        <!-- 奖励内容 -->
        <div
          class="reward-group"
          :class="rewardList.length > 1 ? 'double' : 'single'"
        >
          <div
            v-for="(item, index) in rewardList"
            :key="index"
            class="reward-item flex-col-center"
          >
            <img v-lazy="item.icon" alt="`coupon-icon`" class="coupon-icon" />
            <span>{{ item.desc }}</span>
          </div>
        </div>
      </div>

      <div class="btn-group space-between">
        <button class="detail flex-center" @click="goDetail">
          {{ $t('memberShare.detail') }}
        </button>
        <button class="share flex-center" @click="goShare">
          {{ $t('memberShare.share') }}
        </button>
      </div>
    </div>
  </van-dialog>
</template>
<script>
  // 会员升级弹窗
  import { mapState, mapGetters } from 'vuex'
  import { currentLevelShort, surpassPercent } from '@/utils/members'
  import { textFormat } from '@/utils/pluralRules.js'
  import { moneyFormatRules } from '@/utils/moneyFormatRules'
  import { storage, MembersModalBoxList } from '@/utils/storage'

  export default {
    name: 'MemberToast',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      levelCode: {
        type: Number,
        default: 0,
      },
      couponList: {
        type: Array,
        default: () => [],
      },
      kgoldList: {
        type: Array,
        default: () => [],
      },
      kgoldTotal: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        show: this.value,
        textFormat,
        MembersModalBoxList: storage.get(MembersModalBoxList) || [],
      }
    },
    computed: {
      ...mapState(['members']),
      ...mapGetters(['displayLayout']),
      level() {
        return currentLevelShort(this.levelCode)
      },
      levelUp() {
        // 提升了几个等级
        const membersList = this.MembersModalBoxList || []
        // 获取升级的所有等级
        const levelCodeList = membersList.reduce((prev, curv) => {
          prev.push(curv.messageBody.levelCode)
          return prev
        }, [])
        // 获取去重后的等级个数 eg: [3,4,5]是升了3级
        return new Set(levelCodeList).size
      },
      exceedPercent() {
        // 超越xx.xx%用户
        return surpassPercent(this.levelCode)
      },
      rewardList() {
        // 奖励数据
        let result = []
        // 优惠券
        if (this.couponList.length > 0) {
          // 当只有一张奖励券时：直接展示券面值/折扣
          // 当有多张奖励券时，展示"X n张"
          let couponDesc = textFormat(
            this.$t('memberShare.couponsCount'),
            this.couponList.length
          )

          if (this.couponList.length === 1) {
            const couponData = this.couponList[0]
            if (couponData.couponType * 1 === 1) {
              const couponPrice = this.$options.filters['formatMoney'](
                couponData.couponPrice
              )
              const SymbolInAfter = moneyFormatRules.SymbolInAfter
              couponDesc = SymbolInAfter
                ? `${couponPrice} ${couponData.currency}`
                : `${couponData.currency} ${couponPrice}`
            } else {
              couponDesc = `${100 - couponData.couponDiscount}% OFF`
            }
          }
          result.push({
            icon: require(`@/assets/images/member/coupon-icon.png`),
            desc: couponDesc,
          })
        }
        // T币
        if (this.kgoldTotal > 0) {
          result.push({
            icon: require(`@/assets/images/member/kcoin-icon.png`),
            desc: this.kgoldTotal,
          })
        }
        return result
        // return [
        //   result.push({
        //     icon: require(`@/assets/images/member/coupon-icon.png`),
        //     desc: '1213',
        //   }),
        //   {
        //     icon: require(`@/assets/images/member/kcoin-icon.png`),
        //     desc: '222',
        //   },
        // ]
      },
    },
    mounted() {},
    destroyed() {},
    watch: {
      value(val) {
        this.show = val
      },
    },
    methods: {
      close() {
        this.$emit('input', false)
        this.$emit('close')
      },
      goShare() {
        // 去分享
        this.$emit('onShare')
      },
      goDetail() {
        // 跳转会员页首页
        const name = this.$route?.name || ''
        // 关闭会员弹窗
        this.close()
        // 如果当前页面是会员页面,则不跳转
        if (name === 'membersPrivilege') return
        // 跳转到我的会员页面
        this.$router_push({
          path: '/membersPrivilege',
          query: this.$route.query,
        })
      },
    },
  }
</script>
<style scoped lang="scss" src="./MemberToast.scss"></style>
<style scoped lang="scss" src="./MemberToast_gt.scss"></style>
<style scoped lang="scss" src="./MemberToast_pc.scss"></style>
<style lang="scss">
  .member-modal-overlay.van-overlay {
    background-color: rgba(5, 6, 8, 0.9);
  }
</style>
